export default __webpack_public_path__ + "static/media/fam3.50bacaae.png";